import React from 'react';

import { isMobile } from '../../../core/helpers/isMobile';

import ConnectionPopup from '../connectionPopup';

function ConnectionPopupWrapper() {
  return <ConnectionPopup x={isMobile() ? 0 : 534} y={isMobile() ? 0 : 308} />;
}

export default ConnectionPopupWrapper;
